<template>
    <div class="extension-card-statistic-tooltip">
        <div
            v-for="(item, index) in items"
            :key="'summary-' + index"
            :class="{ 'mb-2': items.length > 1 && index < items.length - 1 }"
        >
            <div class="uppercase text-main-sm font-medium mb-1">
                {{ item.label }}
            </div>
            <div
                v-if="item.values?.length"
                class="flex gap-2"
            >
                <div
                    v-for="(value, valueIndex) in item.values"
                    :key="'value-' + valueIndex"
                    class="flex gap-1 items-center"
                >
                    <RedesignBaseIcon
                        v-if="value.icon"
                        :name="value.icon"
                        :color="value.iconColor"
                    />
                    <div class="text-sm">
                        {{ value.value }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { FullSummaryItem } from '@/composables/useExtensionCardStatistics'

defineProps<{
    items: FullSummaryItem[]
}>()
</script>
